import { render, staticRenderFns } from "./ThePriceCompetitorMain.vue?vue&type=template&id=2d15d0bc&scoped=true&"
import script from "./ThePriceCompetitorMain.vue?vue&type=script&lang=js&"
export * from "./ThePriceCompetitorMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d15d0bc",
  null
  
)

export default component.exports